function t(n) {
  return typeof window < "u" && window.navigator != null && n.test(window.navigator.userAgent);
}
function o(n) {
  return typeof window < "u" && window.navigator != null && n.test(window.navigator.platform);
}
function i() {
  return o(/^iPhone/);
}
function r() {
  return o(/^iPad/) || o(/^Mac/) && navigator.maxTouchPoints > 1;
}
function e() {
  return i() || r();
}
function u() {
  return t(/AppleWebKit/) && !t(/Chrome/);
}
function a() {
  return t(/Android/);
}
export {
  a,
  u as b,
  i as c,
  e as i
};
//# sourceMappingURL=platform-Dk-mE3cE.js.map
